<template>
  <div>
    <Navbar />
    <img class="background" src="@/assets/images/pages/coming_home.svg" />

    <h2 class="welcome">Welcome, {{first_name}}</h2>
    <br/>
    <div class="title">Which store do you wish to go into today?</div>
    <div class="container">
      <div class="company-listing">
        <div v-for="(org, index) in organizations" :key="index" class="company" style="margin: auto; padding: 18px">
          <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <div class="shop-object" @click="switchOrganization(org.id, org.organization_status, org.name, org.subdomain)">
                <div class="shop-header">
                   <div class="flex justify-between text-center">
                      <vs-button  v-if="org.organization_status===2" class="mx-auto mt-1 "  type="gradient" color="#b9b9b9" gradient-color-secondary="#CE9FFC" @click.stop="acceptInvitation(org.id, org.name)" >ACCEPT INVITATION</vs-button>     
                      <vs-button  v-else class="mx-auto mt-1 "  type="gradient" color="#b9b9b9" gradient-color-secondary="#CE9FFC" @click.stop="switchOrganization(org.id, org.organization_status, org.name, org.subdomain)" >GO INTO</vs-button>     
                    </div>
                </div>
                <vs-card class="cardx">
                  <div class="header" slot="header" >
                    <h4 v-if="org.name.length <= 18" class="org-name text-center">{{org.name}}</h4>
                    <h4 v-else class="org-name text-center">{{org.name.substring(0,15)+"..."}}</h4>
                  </div>
                  <div class="media" slot="media">
                    <img src="@/assets/images/pages/shop-body.jpg">
                  </div>
                </vs-card>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import Navbar from '@/views/components/quicksend-navbar/Navbar.vue'
import router from '@/router';
import axios from '@/axios';
import auth from '@/services/authService';
import url from '@/services/urlService';

const dialogs = {
  expired: (error) => {
    return {
      color: "primary", 
      title: "Your current package is expired!",
      text: "Subscribe a new pakcage to unlock the dashboard summary.",
      accept:() => {
        router.push('/billing/current-plan')
      },
      close:() => {
        router.push('/billing/current-plan')
      }
    }
  }
}

export default {
  components: {
    Navbar
  },
  async created() {
    if (_.isEmpty(await this.$store.state.user)) {
      this.$router.push('/login');
    }
  },
  computed: {
    first_name () {
      return this.$store.state.user.email;
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
  },
  methods: {
    async openConfirm(org_id,organization_status,organization_name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Accept Invitation?',
        text: 'Would you like to accept the invitation and go into this store?',
        accept: this.acceptInvitationandSwitch,
        parameters : [org_id,organization_status,organization_name]
      })
    },
    async switchOrganization (org_id, organization_status, organization_name, subdomain) {
      if(organization_status===1)
      {
        try {
          console.log('switching organization');
          let user_id = this.$store.state.user.id;
          await this.$store.dispatch('auth/switchOrganization', { user_id: user_id, organization_id: org_id, acl: this.$acl });
          this.$store.commit('SOFT_RESET_STATE');
          if(this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.user.current_organization).subscription !== null){
            this.$router.push('/dashboard');
          }else{
            this.$vs.dialog(dialogs.expired())
          }
          // window.location.href = url.subdomainUrl(subdomain, 'dashboard');
          
        } catch(e) {
          this.$router.push('/login');
        }
      }
      else
      {
        this.openConfirm(org_id,organization_status,organization_name);
      }
    },
    async acceptInvitation (org_id, organization_name) {
      
       let user_id = this.$store.state.user.id;

      var params={
        'status': '1'
      }

          try {
            let res = axios.patch('/organization/'+org_id+'/user/'+user_id, params);
             
             this.$vs.notify({
                color:'success',
                title:'Invitation has been accepted successfully',
                text:'Congratulations! You are now active member of '+organization_name+'.'
              })

            await this.$store.dispatch('organization/getOrganizations');

          }catch (e) {
            throw e;
          }
      
    },
     async acceptInvitationandSwitch(param) {
      
       let user_id = this.$store.state.user.id;
       let org_id=param[0];
       let organization_name=param[2];

      var params={
        'status': '1'
      }

          try {
            let res = axios.patch('/organization/'+org_id+'/user/'+user_id, params);
             
             this.$vs.notify({
                color:'success',
                title:'Invitation has been accepted successfully',
                text:'Congratulations! You are now active member of '+organization_name+'.'
              })

            try {
              let user_id = this.$store.state.user.id;
              await this.$store.dispatch('auth/switchOrganization', { user_id: user_id, organization_id: org_id });
              let org = this.$store.organization.organizations.find((x) => x.id === org_id);
              this.$store.commit('SOFT_RESET_STATE');
              //window.location.href = url.subdomainUrl(org.subdomain, 'dashboard');
              this.$router.push('/dashboard');
            } catch(e) {
              this.$router.push('/login');
            }
            await this.$store.dispatch('organization/getOrganizations');

          }catch (e) {
            throw e;
          }
      
    }
  },
 created () {
     this.$store.dispatch('organization/getOrganizations');
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style scoped>
body{
	margin:0;
	padding:0;
	width:100%;
	height:100%;
}

.background {
	position: fixed;
	opacity: 0.2;
	z-index: -1;
	top: 0;
}

.container {
	justify-content: center;
	align-content: center;
	/*display: grid;*/
	grid-template-rows: repeat(2,1fr);
	grid-template-areas:
		"title"
		"card";
	justify-items: center;
	align-items: center;
}

.welcome{
	color: #f9278e;
	text-align: center;
	font-weight: bold;
	align-self: start;
	grid-area: title;
	/*text-transform: uppercase;*/
}

.title{
	color: #f9278e;
	text-align: center;
	align-self: center;
	grid-area: title;
}

.org-name {
	text-align: center;
	padding: 1rem;
	text-transform: uppercase;
	color: black;
	border: 5px solid #f9278e;
}

.header {
	max-height: 50px;
}

.company-listing{
	display: flex;
	grid-area: card;
	flex-wrap: wrap;
    align-content: space-between;
	flex: 0 0 21%;	
}

.company{
	max-width: 100%;
	height: 200px;
	cursor: pointer;
}

.cardx {
	margin-left: 10%;
	margin-right: 10%;
}

/*.company:hover {
	-webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
	transform: scale(1.3);
}*/

.shop-header{
	border-bottom: 50px solid #f9278e;
	border-left: 25px solid transparent;
	border-right: 25px solid transparent;
	height: 0;
	width: 120%;
}

.shop-body{
	width: 100%;
	height: 50px;
	background-color: #fff;
	border-radius: 5%;
}


.media{
	margin: 10px;
}

</style>
